export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=409a8ff1192f7be25cd8f9a9218dedb6ce37bf3142&name=getProductServerAction!'